module.exports = __webpack_public_path__ + "img/image00002-min.3de68eda.jpeg";